/* Gamdru: añade el precio de cada variante junto a su nombre en el
 * selector de "Estado" (Usado/Sin caja), ej. "Usado | 44,99€". El HTML
 * que renderiza Shopify solo trae el precio de la variante ya
 * seleccionada, así que pedimos el resto por la API JSON del producto.
 *
 * Shopify reescribe el texto del botón cada vez que se cambia de
 * variante (borrando lo que añadimos), así que en vez de decorarlo una
 * vez y olvidarnos, vigilamos cada picker con su propio observer y lo
 * reaplicamos cuando haga falta.
 *
 * La etiqueta "Más popular" se pinta FUERA del botón (posicionada por
 * JS), nunca dentro del <label>: ese elemento es el que Shopify usa
 * para animar el relleno de fondo al seleccionar (necesita
 * overflow:hidden), y forzar overflow:visible ahí rompe esa animación.
 * Se ancla al <form> del picker, no al <fieldset>: los fieldsets tienen
 * una caja de posicionamiento rara por culpa del <legend> que descuadra
 * los hijos con position:absolute. */
(function () {
  function formatPrice(price) {
    // /products/{handle}.json trae el precio en euros como string (ej. "44.99"),
    // a diferencia del JSON embebido en el picker que sí va en céntimos.
    return parseFloat(price).toFixed(2).replace('.', ',') + '€';
  }

  function positionBadge(anchor, label, badge) {
    var aRect = anchor.getBoundingClientRect();
    var lRect = label.getBoundingClientRect();
    badge.style.left = (lRect.right - aRect.left) + 'px';
    badge.style.top = (lRect.top - aRect.top) + 'px';
  }

  function applyLabels(picker, variantsById) {
    picker.querySelectorAll('input[data-variant-id]').forEach(function (input) {
      var variant = variantsById[Number(input.getAttribute('data-variant-id'))];
      if (!variant) return;
      var wrapper = input.parentElement;
      var label = wrapper.querySelector('[data-key="variant-option-text"]');
      if (!label) return;
      var suffix = ' | ' + formatPrice(variant.price);
      var baseName = input.getAttribute('aria-label') || input.value;
      var target = baseName + suffix;
      if (label.textContent !== target) label.textContent = target;

      // La variante "con caja" (cualquiera que no sea "Sin caja") es la más
      // habitual/popular: le añadimos una etiqueta para orientar la elección.
      var isBoxed = baseName.trim().toLowerCase() !== 'sin caja';
      var anchor = wrapper.closest('.variant-picker__form') || picker;
      if (isBoxed && anchor) {
        anchor.classList.add('gvp-badge-anchor');
        var badge = anchor.querySelector(':scope > .gvp-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'gvp-badge';
          badge.textContent = 'Más popular';
          anchor.appendChild(badge);
        }
        positionBadge(anchor, wrapper, badge);
      }
    });
  }

  function watch(picker, variantsById) {
    applyLabels(picker, variantsById);
    var reposition = function () { applyLabels(picker, variantsById); };
    var observer = new MutationObserver(reposition);
    observer.observe(picker, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', reposition, { passive: true });
  }

  function init(picker) {
    if (picker.hasAttribute('data-gvp-init')) return;
    picker.setAttribute('data-gvp-init', '');
    var handle = picker.getAttribute('data-product-handle');
    if (!handle) return;
    fetch('/products/' + handle + '.json')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var byId = {};
        data.product.variants.forEach(function (v) { byId[v.id] = v; });
        watch(picker, byId);
      })
      .catch(function () { /* si falla, se quedan solo con el nombre, sin precio extra */ });
  }

  function scan() {
    document.querySelectorAll('variant-picker[data-product-handle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Los bloques de la tienda pueden re-renderizarse (secciones dinámicas,
  // quick-add); vigilamos por si aparece un variant-picker nuevo.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
